import api from "../../../utils/api";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import { GET_WORKER_IMPORT_TYPE, GET_WORKER_IMPORT_TYPE_ERROR } from "../types";

export const get_worker_import_type = () => async (dispatch) => {
  try {
    const res = await api.get('api/wor-importdata/get-import-type-list');
    dispatch({
      type: GET_WORKER_IMPORT_TYPE,
      payload: res.data
    });
  } catch (err) {

    handleError(err, dispatch)
    dispatch({
      type: GET_WORKER_IMPORT_TYPE_ERROR
    });
  }
}

export const save_import_data = ({ file, importDuplicates, importType }) => async (dispatch) => {
  try {
    let fd = new FormData();
    fd.append('file', file);
    const res = await api({
      method: "post",
      // Need to add the parameter as per the API.... NOTE
      url: `api/wor-importdata/save-import-data?importDuplicates=${importDuplicates}&importType=${importType}`,
      data: fd,
      headers: { "Content-Type": "multipart/form-data" },
    });
    dispatch(setAlert(res.data.message, "success"));
    return res.data.data;
  } catch (err) {
    handleError(err, dispatch)
    return false;
  }
}